import { observable, computed, action, reaction } from 'mobx'
import Setting from '../Model/Setting'
import ActionsLocalService from '../Services/ActionsLocalService'
import { ExportType } from './ExportStore'

export default class SettingsStore {
    @observable
    private settings: Array<Setting>

    @observable
    private settingToDelete: Setting | null | undefined

    @computed
    get getSettings() {
        return this.settings
    }

    @action.bound
    set(data: Array<Setting>) {
        this.settings = data
    }

    @computed
    get getSettingToDelete() {
        return this.settingToDelete
    }

    @action.bound
    setSettingToDelete(settingToDelete: Setting | null | undefined) {
        this.settingToDelete = settingToDelete
    }

    private constructor() {
        reaction(
            () => this.settings,
            (x) => {
                let data = this.settings
                ActionsLocalService.getInstance().setExportData(ExportType.Settings, data)
            }
        )
    }

    private static _instance: SettingsStore

    public static getInstance(): SettingsStore {
        return this._instance || (this._instance = new this())
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Stores/SettingsStore.tsx